import { SavedList } from 'services/savedLists/types';
import {
  PAGE_LIMIT,
  PAGE_SIZE_OPTIONS,
  SAVED_LIST_DEFAULT_MANAGE_VIEW_PREFERENCES
} from './_constants/common';
import { getModifiedUserAttributes } from 'hooks/use-manage-user-attributes/actions';

export const isNumber = <T>(value: T): boolean => !isNaN(Number(value));

export const transformQueryParams = (queryParams) => {
  return {
    ...queryParams,
    limit: isNumber(queryParams.limit)
      ? getValidateLimit(queryParams.limit)
      : PAGE_LIMIT,
    page: isNumber(queryParams.page) ? queryParams.page : 1
  };
};

export const getPaginatedList = (
  { limit, page, list }: { list: SavedList[]; page: number; limit: number } = {
    limit: PAGE_LIMIT,
    page: 1,
    list: []
  }
) => {
  const begin = (page - 1) * limit;
  const end = begin + limit;
  return list.slice(begin, end);
};

export const getValidateLimit = (limit: number): number =>
  PAGE_SIZE_OPTIONS.includes(limit) ? limit : PAGE_LIMIT;

export const isUndefined = (item: unknown) => item === undefined;

export const getSavedListManageViewPreferences = async () => {
  const { defaultShowOnlyMyFavorites, defaultShowOnlyMyLists } =
    SAVED_LIST_DEFAULT_MANAGE_VIEW_PREFERENCES;

  const {
    savedList_showOnlyMyFavorites: isFavorite,
    savedList_showOnlyMyList: isSelfShoppingList
  } = await getModifiedUserAttributes();

  const manageViewPreferences = {
    isFavorite: isUndefined(isFavorite)
      ? defaultShowOnlyMyFavorites
      : isFavorite,
    isSelfShoppingList: isUndefined(isSelfShoppingList)
      ? defaultShowOnlyMyLists
      : isSelfShoppingList
  };

  return manageViewPreferences;
};

export const sortByName = (arr) => {
  const c = (a, b) =>
    a.customerOrganizationBusinessName > b.customerOrganizationBusinessName
      ? 1
      : 0;
  return arr.toSorted((a, b) =>
    a.customerOrganizationBusinessName < b.customerOrganizationBusinessName
      ? -1
      : c(a, b)
  );
};
